// src/components/Register.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../assets/css/register.css";
import AdminNavBar from "../components/AdminNavbar";
import HODSidebar from "../components/HODSidebar";

const isProduction = process.env.NODE_ENV === "production";
// Prefer reading URL from an env variable in real projects (see notes below)
const API_BASE_URL = isProduction
  ? "https://schools.luth.gov.ng"
  : "http://localhost:3003";

// Option A: set axios default base URL once (recommended)
axios.defaults.baseURL = API_BASE_URL;

export default function HODRegister() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("student");
  const [matricNo, setMatricNo] = useState("");
  const [username, setUsername] = useState("");
  const [programme, setProgramme] = useState("");
  const [programmes, setProgrammes] = useState([]);
  const [error, setError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        // Option B: or explicitly use `${API_BASE_URL}/api/programmes`
        const res = await axios.get("/api/programmes"); // uses axios.defaults.baseURL
        setProgrammes(res.data);
      } catch (err) {
        console.error("Error fetching programmes", err);
      }
    })();
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const normalizedRole = String(role || "")
        .trim()
        .toLowerCase();

      await axios.post("/api/register", {
        fullName,
        email,
        password,
        role: normalizedRole,
        programme,
        matricNo: normalizedRole === "student" ? matricNo : null,
        username: normalizedRole !== "student" ? username : null,
      });

      setShowSuccess(true);
    } catch (err) {
      setError(
        err.response?.status === 409
          ? err.response.data.msg
          : "Registration failed. Please try again.",
      );
    }
  };

  const handleSuccessOk = () => {
    setShowSuccess(false);
    window.location.reload();
  };

  return (
    <div className="staff-dashboard" style={{ marginTop: "-130px" }}>
      <HODSidebar />
      <div className="register-page" style={{ marginLeft: "250px" }}>
        <div className="register-container">
          <h2>Register</h2>
          {error && <p className="error-message">{error}</p>}
          <form onSubmit={handleRegister}>
            <input
              type="text"
              placeholder="Full Name"
              className="register-input"
              onChange={(e) => setFullName(e.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Email"
              className="register-input"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Password"
              className="register-input"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {/* <select
              className="register-input"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="student">Student</option>
              <option value="staff">Staff</option>
              <option value="admin">Admin</option>
            </select> */}
            <select
              className="register-input"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="student">Student</option>
              <option value="staff">Staff</option>
              {/* <option value="hod">HOD</option>
              <option value="admin">Admin</option> */}
            </select>

            {role === "student" && (
              <input
                type="text"
                placeholder="Matric No"
                className="register-input"
                onChange={(e) => setMatricNo(e.target.value)}
                required
              />
            )}

            {role !== "student" && (
              <input
                type="text"
                placeholder="Username"
                className="register-input"
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            )}

            {role !== "admin" && (
              <select
                className="register-input"
                value={programme}
                onChange={(e) => setProgramme(e.target.value)}
                required
              >
                <option value="">Select Programme</option>
                {programmes.map((prog, idx) => (
                  <option key={idx} value={prog.Programme}>
                    {prog.Programme}
                  </option>
                ))}
              </select>
            )}

            <button type="submit" className="register-button">
              Register
            </button>
          </form>
        </div>

        {showSuccess && (
          <div className="modal-overlay">
            <div className="modal">
              <h3>Success!</h3>
              <p>Your account has been created.</p>
              <button onClick={handleSuccessOk}>OK</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
